module.exports = __webpack_public_path__ + "img/usa-transport-accidents-female.b5d7c694.png";